module.exports = __webpack_public_path__ + "static/ankur-86cbe9361468d05c346b381af37beda2.svg";